var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-fit rounded bg-primary-darker px-1 py-[0.125rem] text-xs font-bold uppercase text-white"},[_vm._v(" "+_vm._s(_vm.$t('app.free'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }